
import { Enums } from '@bode-canada/core';
import Typography from '@/ui-kit/components/typography';
import Gutter from '@/ui-kit/components/gutter';
import { StyleSizeType, StylePositionType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ExternalLink from '@/ui-kit/components/external-link';
import { ExternalLinks } from '@/utils/external-navigation/constants';

export default {
  name: 'ListingOwnerContactsMlsContact',
  components: {
    Typography,
    Gutter,
    ExternalLink,
  },
  props: {
    origin: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      StyleSizeType,
      StylePositionType,
      StyleColorSchemeType,
      ExternalLinks,
    };
  },
  computed: {
    isTRREBListing() {
      return this.origin === Enums.ListingOriginEnum.REPLIERS_TRREB;
    },
  },
  methods: {
    handleExternalLinkClick() {
      this.$emit('external-link-click');
    },
  },
};
